import { createApi } from '@reduxjs/toolkit/query/react'
import { axiosBaseQuery } from '../services/rest'

export const apiService = createApi({
    baseQuery: axiosBaseQuery,
    keepUnusedDataFor: 60, // cache life (sec)
    refetchOnReconnect: true,
    tagTypes: ['Stock', 'StockModalProducts', 'StockSchedule', 'Menu', 'MainMeta', 'Warehouse', 'Statistics'],
    endpoints: () => ({}),
})
